import { create } from 'zustand';
import { getActions } from './actions.js';
export const DEFAULT_USER_INFO_STATE = { email: '', phone: '', countryCode: '+1' };
export const useUserInfoStore = create(set => (Object.assign(Object.assign({}, DEFAULT_USER_INFO_STATE), getActions(set))));
